import { call, put, takeLatest } from "redux-saga/effects";
import {
GET_POTENTIAL,
ADD_POTENTIAL,
UPDATE_POTENTIAL,
DELETE_POTENTIAL,
GET_POTENTIAL_SUCCESS,
ADD_POTENTIAL_SUCCESS,
UPDATE_POTENTIAL_SUCCESS,
DELETE_POTENTIAL_SUCCESS,
} from "../../redux/actions/actionType";
import api from "../../apis/api";
import { updatePotential } from "../../redux/actions/adminSettings/adminSettings.action";

// api function.
function getPotentialApi()  {
    // api for get attribute list
   const response = api.dbPotential().GetPotentialsList();
    return response;
  }
  function addPotentialApi(formData) {
    // api for add  attribute.
    const response = api.dbPotential().AddEditPotentials(formData);
    return response;
  }
  function updatePotentialApi(formData) {
    // api for update  attribute.
    api.dbPotential().AddEditPotentials(formData);
  }
  function deletePotentialApi(delId) {
    // api for delete  attribute.
    const response = api.dbPotential().DeletePotentials(delId);
    return response;
  }
  
export function* handleGetPotential() {
    try {
      const response = yield call(getPotentialApi);
      yield put({ type: GET_POTENTIAL_SUCCESS, payload: response.data });
    } catch (error) {
 
    }
  }
  export function* handleAddPotential({ payload }) {
    try {
    const responsea= yield call(addPotentialApi, payload);
      payload={...payload,"potentialId":responsea.data}
      yield put({ type: ADD_POTENTIAL_SUCCESS, payload: payload });
      
    } catch (error) {
 
    }
  }
  export function* handleUpdatePotential({ payload }) {
    try {
      let formData = payload;
      yield call(updatePotentialApi, formData);
      yield put({ type: UPDATE_POTENTIAL_SUCCESS, payload: formData });
    } catch (error) {

    }
  }
  export function* handleDeletepotential({ payload }) {
    try {
      yield call(deletePotentialApi, payload);
      yield put({ type: DELETE_POTENTIAL_SUCCESS, payload: payload });
    } catch (error) {
     
    }
  }
  
  // watach function.
  export function* PotentialWatchFun() {
    yield takeLatest(GET_POTENTIAL, handleGetPotential);
    yield takeLatest(ADD_POTENTIAL, handleAddPotential);
    yield takeLatest(UPDATE_POTENTIAL, handleUpdatePotential);
    yield takeLatest(DELETE_POTENTIAL, handleDeletepotential);
  }